export const commons = {
  languages: {
    A1: 'A1 - Beginner',
    A2: 'A2 - Elementary',
    B1: 'B1 - Intermediate',
    B2: 'B2 - Upper Intermediate',
    C1: 'C1 - Advanced',
    C2: 'C2 - Proficient',
    Native: 'Native Language'
  },
  roles: {
    club: 'Club',
    artist: 'Artist',
    admin: 'Admin'
  },
  artistJobs: {
    Hostess: 'Hostess',
    GoGo: 'GoGo',
    Strip: 'Strip'
  },
  schedule: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday'
  },

  contractWeeks: '{count, plural, one {# week} other {# weeks}}',

  paymentFrequency: {
    Daily: 'Day',
    Weekly: 'Week',
    Monthly: 'Month'
  },
  flightPaymentType: {
    Club: 'Paid by club',
    Artist: 'Paid by artist',
    Credit: 'Ticket credit',
    Agreement: 'By agreement',
    Compensation: 'Compensation'
  },
  artistConsumation: {
    label: 'Consumption',
    Active: 'Active',
    Passive: 'Passive'
  },
  workItemType: {
    Request: 'Requests',
    Invite: 'Invitations'
  },
  workItemStatus: {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    Withdrawn: 'Withdrawn',
    Expired: 'Expired',
    ContractOngoing: 'Contract active',
    ContractRequestedEndDate: 'End date requested',
    FinishingContract: 'Contract ending soon',
    ContractCompleted: 'Contract completed',
    ClubSetEndDate: 'Club set the end date',
    Cancelled: 'Cancelled'
  },
  artistStatuses: {
    LookingForWork: 'Looking for work',
    OnContract: 'Under contract',
    FinishingContract: 'Finishing contract',
    OnVacation: 'On holiday',
    HiddenFromSearch: 'Hidden from search'
  },
  loading: {
    generic: 'Loading data...',
    requests: 'Loading requests...',
    invites: 'Loading invitations...'
  },
  flightCompensationOptions: {
    oneMonth: 'After 1 months',
    twoMonths: 'After 2 months',
    threeMonths: 'After 3 months',
    sixMonths: 'After 6 months, club buys return ticket',
    backTicket: 'Return ticket'
  },
  transportFromAirport: {
    label: 'Transport from the airport or station',
    options: {
      clubOrganizes: 'Organised by the club',
      artistSelf: 'The artist arranges their own transport'
    }
  },
  notFound: {
    generic: 'The list is empty.',
    requests: 'There are no requests yet.',
    invites: 'There are no invitations yet.',
    artists: 'The artist list is currently empty',
    search:
      'We couldn’t find a club that matches your request. Please let our support team know so we can improve the search.'
  },
  artistParametres: {
    weight: 'Weight',
    height: 'Height',
    body: 'Body type',
    chest: 'Chest',
    waist: 'Waist',
    hips: 'Hips'
  },
  dressCodeOptions: {
    strip: 'Stripper heels',
    underwear: 'Underwear',
    longDress: 'Long dress',
    body: 'Bodysuit',
    shortDress: 'Short dress'
  },

  time: {
    years: '{count, plural, one {# year} other {# years}}',
    months: '{count, plural, one {# month} other {# months}}',
    days: '{count, plural, one {# day} other {# days}}'
  },
  contact_support: 'Need help? Contact support',
  success_send_data: 'Data submitted successfully',
  worked_for: 'Worked at ',
  club_reviews: 'Club reviews',
  club_response: 'Club response',
  response: 'Reply',
  send: 'Send',
  cm: 'cm',
  kg: 'kg',
  no_rating_yet: 'This club has not been rated yet',
  rating_allow: 'Artists can rate the club only after working for 21 days',
  rating: 'rating',
  rating_popup_header_1: 'Your contract at the club ',
  rating_popup_header_2: ' has ended',
  rating_popup_text:
    'It is important for us and other artists to know your opinion about this place. Please rate your experience at this club.',
  error_rating: 'Could not submit the rating',
  no_rating:
    'There is nothing to rate for this club or it has already been rated',
  housing_quality: 'Accommodation quality',
  dressing_quality: 'Changing room quality',
  management: 'Management and staff',
  anonymous: 'Leave feedback anonymously',
  rate_work: 'Rate your experience at this club',
  submit: 'Submit',
  cancel: 'Cancel',
  years: 'years',
  allow_note: 'Allow push notifications',
  allow_note_1:
    'Enable push notifications so the platform works properly and you do not miss important updates:',
  allow_note_2: 'Requests and invitations',
  allow_note_3: 'Responses from clubs',
  allow_note_4: 'Messages from artists or managers',
  allow_note_5: 'We only send work-related notifications — no spam.',
  'follow-us-in-social': 'Follow us on social media:',
  continue: 'Continue',
  'continue-with-google': 'Continue with Google',
  artistHiringIsOpen: 'Artist hiring is open',
  artistHiringIsClosed: 'Artist hiring is closed',
  acceptWithExperience: 'We hire without experience',
  dontAcceptWithoutExperience: 'We do not hire without experience',
  info: 'Info',
  copyLink: 'Copy link',
  withExperience: 'With experience',
  withouthExperience: 'No experience',
  agree: 'I agree to the terms',
  change: 'Change',
  add: 'Add',
  citizenship: 'Citizenship',
  save: 'Save',
  'save-and-continue': 'Save and continue',
  edit: 'Edit',
  portfolio: 'Portfolio',
  close: 'Close',
  closed: 'Closed',
  finish: 'Finish',
  help: 'Help',
  logout: 'Logout',
  country: 'Country',
  place: 'Place',
  deleteAccount: 'Delete account',
  changePassword: 'Change password',
  hide: 'Hide',
  show_full: 'Show full text',
  selectCountry: 'Select a country',
  delete: 'Delete',
  exit: 'Yes, log me out',
  'undo-to-account': 'Return to account',
  location: 'Location',
  language: 'Languages',
  reviews: 'Reviews',
  parametres: 'Measurements',
  about: 'About me',
  my: 'My',
  photo: 'Photos',
  video: 'Videos',
  experience: 'Experience',
  galery: 'Gallery',
  write: 'Write',
  yes: 'Yes',
  step: 'Step',
  no: 'No',
  or: 'Or',
  resend: 'Send again',
  open: 'Open',
  need: 'Needed',
  dontNeed: 'Not needed',
  endWork: 'End of work',
  startDate: 'Work start date',
  endDate: 'Work end date',
  vacancy: 'Vacancy',
  creditation: 'Ticket credit',
  aroundTheClock: 'Open 24/7',
  flightTickets: 'Flight tickets',
  ticketCreditation: 'Ticket credit',
  crazyMenu: 'Crazy menu',
  tea: 'Tips',
  show: 'Show',
  deposit: 'Deposit',
  guarantee: 'Guarantee',
  rate: 'Rate',
  clubFee: 'Club fee',
  separated: 'Separate',
  forShift: 'Per shift',
  required: 'Required',
  optional: 'Optional',
  quantity: 'Quantity',
  choreographerInClub: 'Choreographer',
  photoshootParticipation: 'Participation in photo shoots',
  artistsInShift: 'Artists per shift',
  scenes: 'Stages',
  dynamicPole: 'Dynamic poles',
  staticPole: 'Static poles',
  artistTraining: 'Training for artists',
  teching: 'Coaching',
  dressCodeForArtists: 'Dress code for artists',
  dressCode: 'Dress code',
  rentPayment: 'Rent payment',
  utilitiesPayment: 'Utility bills',
  clubProvidedAccommodation: 'Club-provided accommodation',
  housingPhoto: 'Accommodation photo',
  noteEditLater: 'You can edit this later',
  paydByArtist: 'Paid by the artist',
  paydByClub: 'Paid by the club',
  peopleInRoom: 'People per room, up to',
  uploadFromDevice: 'Upload from your device',
  selectMainPhoto: 'Choose main photo',
  videoParams:
    'The video must not exceed {size} MB. Supported formats: MP4, QuickTime.',
  photoParams: 'Each photo must not exceed {size} MB',
  photoParamsHousing: 'Each photo must not exceed 5 MB. Maximum of 5 photos.',
  general: 'General',
  payments: 'Payments',
  full: 'Full service',
  topless: 'Topless',
  gogo: 'Go-go',
  crazymenu: 'Crazy menu',
  continueFilling: 'Continue filling in',
  exitShort: 'Exit',
  search: 'Search',
  other: 'Other',
  foreignLanguages: 'Foreign languages',
  dancer: 'Dancer',
  untilNow: 'Until now',
  invite: 'Invite',
  cancelInvite: 'Cancel invitation',
  dateFormatPlaceholder: 'dd.mm.yy',
  askArtist: 'Ask the artist a question',
  askClub: 'Ask the club a question',
  reject: 'Reject',
  accept: 'Accept',
  confirm: 'Confirm',
  iConfirm: 'I confirm',
  workAt: 'Working since',
  setLastDate: 'Set the last date',
  lastWorkDay: 'Last work day',
  cancelArrangement: 'Cancel arrangement',
  back: 'Back',
  wantedVacancy: 'Desired vacancies',
  addClub: 'Add club',
  goToInvitation: 'View invitation',
  goToRequest: 'View request',
  vacancyConsider: 'Which vacancies are you considering?',
  super: 'Great',
  withouthExprience: 'No experience',
  uploadManyFromDevice: 'Upload multiple photos from your device',
  clubLocation: 'Club location',
  specify: 'Specify',
  housing: 'Accommodation',
  position: 'Position',
  guest: 'Guest',
  workingHours: 'Working hours',
  isPaydByClub: 'Paid by the club',
  isntPaydByClub: 'Not paid by the club',
  utilityPayments: 'Utility payments',
  payment: 'Payment',
  request: 'Request',
  penalties: 'Penalties',
  aboutClub: 'About the club',
  sendRequest: 'Submit application',
  cancelRequest: 'Withdraw application',
  profile: 'Profile',
  chat: 'Chat',
  housigInClubApartsRequired: 'Club-provided accommodation is mandatory'
};
